import  CheckCircle  from "@material-ui/icons/CheckCircle";
import WarningRounded from "@material-ui/icons/WarningRounded";
import { Collection } from "@type-r/models";
import { div, Flex, InlineTable, TableCell, TableHeader, TableRow, asTimelessDate, asCurrency } from "lqx-react";
import React from "react";
import { BoundPolicyInvoice } from "../api/boundPolicy";
import { DigiTooltip } from "../shared";

export const BoundPolicyBuyerInvoices = ({ invoices }: { invoices: Collection<BoundPolicyInvoice> }) => {
    return <>
        <TableContainer>
            <InlineTable noBorders stickyHeader>
                <TableHeader>
                    <TableCell>STATUS</TableCell>
                    <TableCell>INVOICE #</TableCell>
                    <TableCell>BUYER</TableCell>
                    <TableCell>SUPPLIER</TableCell>
                    <TableCell>FACE VALUE</TableCell>
                    <TableCell>NET FACE VALUE</TableCell>
                    <TableCell>ANT.STLMT DATE</TableCell>
                </TableHeader>
                { invoices.map((invoice: BoundPolicyInvoice) =>
                    <TableRow key={ invoice.cid }>
                        <TableCell>
                            { invoice.isEligible ?
                                <EligibleValue><CheckCircle color="primary" />&nbsp;Eligible</EligibleValue>
                                :
                                <DigiTooltip
                                    title={ invoice.ineligibleReasons.map(reason => <Flex row>{ reason }</Flex>) }
                                    arrow={ true }>
                                    <IneligibleValue><WarningRounded color="error" />&nbsp;Ineligible</IneligibleValue>
                                </DigiTooltip>
                            }
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ invoice.assetDetails.number } </TableFormValue>
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ invoice.assetDetails.buyer ? invoice.assetDetails.buyer.name : 'N/A' } </TableFormValue>
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ invoice.assetDetails.supplier ? invoice.assetDetails.supplier.name : 'N/A' } </TableFormValue>
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ asCurrency(invoice.assetDetails.faceValue) } </TableFormValue>
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ asCurrency(invoice.assetDetails.adjustedFaceValue) }</TableFormValue>
                        </TableCell>
                        <TableCell>
                            <TableFormValue>{ asTimelessDate(invoice.assetDetails.anticipatedSettlementDate) }</TableFormValue>
                        </TableCell>
                    </TableRow>
                ) }
            </InlineTable>
        </TableContainer>
    </>
}

const TableContainer = div({
    marginLeft: '30px',
    marginRight: '30px',
});

const TableFormValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    paddingTop: '5px',
    marginTop: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});

const EligibleValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: '#01c38d',
    marginTop: '2px',
});

const IneligibleValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: '#c32501',
    marginTop: '2px',
    width: '100%'
});
